import React from "react";
import { WiMoonAltWaningCrescent4 } from "react-icons/wi";
import { useTheme } from "../../contexts/ThemeContext";

const Themetoggle = () => {
  const { toggleTheme } = useTheme();

  return (
    <div className='nav_ac nav_ac:hover' onClick={toggleTheme}>
      <WiMoonAltWaningCrescent4 />
    </div>
  )
};

export default Themetoggle;
